import React from "react";
import "../../styles/About/TextAnimation.scss";
import Marquee from "react-fast-marquee";
import textAnimation from "../../assets/images/MezroStripes.jpg";
import textAnimation2 from "../../assets/images/MezroStripes2.jpg";
import textAnimation3 from "../../assets/images/MezroStripes3.jpg";
const TextAnimataion = () => {
  return (
    <div>
      <Marquee gradient={false} speed={20}>
        <img
          src={textAnimation}
          alt=""
          className="img-fluid w-100 text-animation-img pe-3"
        />
      </Marquee>
      <Marquee gradient={false} speed={30}>
        <img
          src={textAnimation2}
          alt=""
          className="img-fluid w-100 text-animation-img pe-3"
        />
      </Marquee>
      <Marquee gradient={false} speed={40}>
        <img
          src={textAnimation3}
          alt=""
          className="img-fluid w-100 text-animation-img pe-3"
        />
      </Marquee>
    </div>
  );
};

export default TextAnimataion;
